'use strict';

/**
 * BD.CollectionLoader: Loads all elements of a collection and calls a callback
 */

var BD = window.BD = window.BD || {};
BD.CollectionLoader = (function($) {
  function load(collectionHandle, callback) {
    this.callback = callback;
    this.collectionHandle = collectionHandle;
    this.loading = false;
    this.pagesComplete = false;
    this.lastRetrievedPage = 0;
    this.$allProducts = $('<div style="display: none"></div>').appendTo('body');

    this.loadNextPage = loadNextPage;
    this.loadNextPage();
    
    this.complete = complete;
    
    return this;
  }
  
  /**
   * Retrieve the next (or first) page of the tours, cache the results, and
   * start loading the next page.
   */
  function loadNextPage() {
    if (this.pagesComplete || this.loading) {
      return;
    }
    
    this.loading = true;
    this.lastRetrievedPage++;
    
    var url = '/collections/' + this.collectionHandle + '?view=raw&page=' + this.lastRetrievedPage;

    $.ajax(url, {
      success: (response) => {

        if (!response.trim()) {
          this.complete();
        }
        
        this.$allProducts.append(response);
        
        var $hasMoreIndicator = this.$allProducts.find('span.more-indicator');

        if ($hasMoreIndicator.length) {
          window.setTimeout(() => this.loadNextPage(), 1);
          $hasMoreIndicator.remove();
        }
        else {
          this.complete();
        }
      },
      complete: () => { this.loading = false; }
    });
  }
  
  function complete() {
    this.loading = false;
    this.callback && this.callback(this);
  }
  
  
  return {
    load: load
  }
})(jQuery);